/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TicketOrderListItem } from './TicketOrderListItem';
import {
    TicketOrderListItemFromJSON,
    TicketOrderListItemFromJSONTyped,
    TicketOrderListItemToJSON,
    TicketOrderListItemToJSONTyped,
} from './TicketOrderListItem';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface Response
 */
export interface Response {
    /**
     * 
     * @type {Array<TicketOrderListItem>}
     * @memberof Response
     */
    items: Array<TicketOrderListItem>;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof Response
     */
    totalCount: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the Response interface.
 */
export function instanceOfResponse(value: object): value is Response {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    return true;
}

export function ResponseFromJSON(json: any): Response {
    return ResponseFromJSONTyped(json, false);
}

export function ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(TicketOrderListItemFromJSON)),
        'totalCount': ApiUserTasksGetPageParameterFromJSON(json['totalCount']),
    };
}

export function ResponseToJSON(json: any): Response {
    return ResponseToJSONTyped(json, false);
}

export function ResponseToJSONTyped(value?: Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(TicketOrderListItemToJSON)),
        'totalCount': ApiUserTasksGetPageParameterToJSON(value['totalCount']),
    };
}

